import i18n from '@/locales/i18n'

export const t = i18n.global.t 